import { Fragment } from 'react';
import { useAuth } from '../context/AuthContext';
import { getVisitAuthToken } from '../lib/api';

// Dispose all tenant-local state together, before rendering the next workspace.
// Regular access-token refreshes must not discard open forms.
export default function AuthScopeBoundary({ children, fallback }) {
  const { user, token, isAuthenticated, loading } = useAuth();
  const visitToken = getVisitAuthToken();
  const visiting = user?.is_admin_visit === true || user?.auth_type === 'admin_visit';
  if (loading || (isAuthenticated && !user) ||
      (visitToken && (!visiting || token !== visitToken)) || (!visitToken && visiting)) return fallback;
  const scope = JSON.stringify([user?.id, user?.org_id, user?.role, visiting ? visitToken : 'account']);
  return <Fragment key={scope}>{children}</Fragment>;
}
